<div>
<mat-sidenav-container [hasBackdrop]=backDropIsActivated >
  <mat-sidenav-content>
    <mat-tab-group mat-stretch-tabs dynamicHeight="true"
      style="min-height : calc(100% - 56px) !important; max-height: 100% !important; ">
      <mat-tab style="min-height : calc(100% - 56px) !important; ">
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">history</mat-icon>
          <span class="tabTitle">Appels à support</span>
        </ng-template>
        <div class="white-rounded-container width-100vw max-height-in-sidenav" style="position: fixed;">
          <div>
            <div class="table-button-container">
              <button mat-icon-button color="primary" aria-label="collapse" (click)="refresh()">
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
            <div>
              <app-prime-ng-array-d4 arrayName="appelASupport" nullArrayDisplayText="Aucun ticket" columnResizeMode="fit" [scrollHeightOffset]="-20"
                [columnsDefinition]="columnsDefinition" [objectList]="tickets" [heightMode]="'variable'" [loading]="loading"
                (rowClick)="displayappelASupport($event)">
              </app-prime-ng-array-d4>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">add_circle</mat-icon>
          <span class="tabTitle">Déclarer un appel à support</span>
        </ng-template>
        <div class="white-rounded-container" style="width: 100%;">
          <app-ajout-appel-a-support *ngIf="!loading" [listSociety]="societyList"></app-ajout-appel-a-support>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-sidenav-content>

  <mat-sidenav position="end" #snav mode="over" [disableClose]=sideNavIsDisable fixedInViewport="true"
    [fixedTopGap]=topGapSidenavRight fixedBottomGap=0 autofocus="true" class="side-nav-container">
    <div *ngIf="!scrollinInBottom" class="encircle bounce animated" (click)="setScrollToBottom()">
      <div class="arrow" (click)="setScrollToBottom()">
        <mat-icon class="arrow-icon">expand_more</mat-icon>
      </div>
    </div>
    <!-- listappelASupports -->
    <mat-sidenav-content (scroll)="myScrollHandler($event)" #detailAS>
      <ng-container *ngIf="!loading && selectedAppelASupport != null">
        <app-detail-appel-a-support [appelASupport]="selectedAppelASupport" [listSociety]="societyList"
          [teamMember]="teamMember" style="min-height:calc(100% - 202px)" (componentHeight)="asDetailHeight($event)"
          (closeEvent)="closeSideNav()">
        </app-detail-appel-a-support>
      </ng-container>
    </mat-sidenav-content>
  </mat-sidenav>
</mat-sidenav-container>
</div>